'use client';

import { DropdownIcon } from '@/components/icons/svg-icons';
import { Button } from '@nf/ui';

interface TopbarMatchListDropdownButtonProps {
	isListOpen: boolean;
	handleListOpen?: () => void;
	isLive: boolean;
	isAlignRight?: boolean;
	isAsideLayout: boolean;
}

/** Single Match > Top Bar > Match List 的展開/收合按鈕 */
export const TopbarMatchListDropdownButton = ({
	isListOpen,
	handleListOpen,
	isLive,
	isAlignRight,
	isAsideLayout,
}: TopbarMatchListDropdownButtonProps) => {

	return (
		!isAsideLayout && isLive ? (
			<Button
				className={isAlignRight ? 'btn--dropdown' : ''}
				variant={'icon'}
				data-active={isListOpen}
				onClick={() => typeof handleListOpen === 'function' && handleListOpen()}
			>
				<DropdownIcon />
			</Button>
		) : null
	)
};